import { t } from "i18next";
import { CorePropsInterfaces, DTOs } from "src/core/Models";
import GtDialog from "./GtDialog";
import { Button } from "@mui/material";

function GtEngagementLetterRegenerateConfirmModal({
  onConfirm,
  onDialogClose,
  title,
  message,
  messageInfo,
}: CorePropsInterfaces.GtEngagementLetterDocumentsManagerDeleteDialogProps): JSX.Element {
  const finalDocumentDialogDTO: DTOs.GtDialogDTO = {
    data: {
      maxWidth: "xs",
      leftButtons: [],
      rightButtons: [
        <Button
          onClick={onDialogClose}
          color="tertiary"
          variant="outlined"
          key="cancelBtn"
        >
          {t("General.Cancel")}
        </Button>,
        <Button
          color="tertiary"
          variant="contained"
          key="confirmBtn"
          onClick={onConfirm}
        >
          {t("General.Ok")}
        </Button>,
      ],
      title: (
        <span className="gt-deleteDocumentDialogIcon">
          {t(title || "General.ConfirmEngagementLetterRegenerationModalTitle")}
        </span>
      ),
    },
    api: {
      onClose: onDialogClose,
    },
    state: {
      isOpen: true,
      isFullWidth: true,
    },
  };

  return (
    <GtDialog gtDialogDTO={finalDocumentDialogDTO}>
      <article className="gt-deleteDocumentDialog">
        <section className="gt-deleteDocumentDialog__content">
          <span className="gt-deleteDocumentDialog__content-explanation">
            {t(
              message ||
                "General.ConfirmEngagementLetterRegenerationModalMessage"
            )}
          </span>
          {(messageInfo || !message) && (
            <>
              <br />
              <br />
              <span className="gt-deleteDocumentDialog__content-explanation">
                {t(
                  messageInfo ||
                    "General.ConfirmEngagementLetterRegenerationModalMessageInfo"
                )}
              </span>
            </>
          )}
        </section>
      </article>
    </GtDialog>
  );
}

export default GtEngagementLetterRegenerateConfirmModal;
